import styled from "styled-components";

export const NFTListContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    // ${({ theme }) => theme.mediaWidth.upToLarge`
    //     flex-direction: column;
    // `}
`

export const ListFilterContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    //justify-content: space-between;
    width: 100%;
    height: 66px;
    padding: 1rem;
    flex-wrap: wrap;
    > div {
        margin-right: 1rem;
    }
    ${({ theme }) => theme.mediaWidth.upToLarge`
        flex-direction: row;
        width: 100%;
        height: 150px;
    `}
`
export const ListItemsWrapper = styled.div`
    height: calc(100% - 66px);
    width: 100%;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        height: calc(100% - 150px);
    `}
`

export const ListItemsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    grid-template-rows: 500px;
    //grid-column-gap: 32px;
    grid-row-gap: 32px;
    padding: 1rem;
    padding-top: 2rem;
`

export const ListFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-bottom: 2rem;
`

export const ListLoader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
`